/* eslint-disable max-lines */
import otherUtils from '@mdm/utils/otherCommonFunc';
import btnAuthority from '@mdm/btnAuthority';
import { urlRegNoRequireHttps, phoneReg } from '@/modules/mdm/utils/regList.js';
export const tableConfig = {
    selection: false,
    index: false,
    columns: [
        {
            label: '客户名称',
            prop: 'customerName',
            mustFill: true,
            width: 180
        },
        {
            label: '客户系名称',
            prop: 'customerGroupName',
            width: 150
        },
        {
            label: '客户等级',
            prop: 'customerLevel',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
            width: 100
        },
        {
            label: '客户经理/开发人',
            prop: 'customerOwnerName',
            width: 150
        },
        {
            label: '投标网站名称',
            prop: 'websiteName',
            width: 140,
            type: 'input',
            maxlength: 200,
            mustFill: true
        },
        {
            label: '投标网址',
            prop: 'websiteUrl',
            width: 180,
            type: 'slot',
            verify: urlRegNoRequireHttps,
            mustFill: true,
            slot: true
        },
        {
            label: '投标账号类型',
            prop: 'accountType',
            type: 'slot',
            slot: true,
            editSlot: true,
            disabled: true,
            optionsKey: 'CUSTOMER_TENDERER_ACCOUNT_TYPE',
            width: 110
        },
        {
            label: '账号',
            prop: 'websiteAccount',
            width: 130,
            type: 'slot',
            slot: true,
            mustFill: true
        },
        {
            label: '密码',
            prop: 'accountPassword',
            width: 120,
            type: 'slot',
            slot: true,
            mustFill: true
        },
        {
            label: '账号状态',
            prop: 'accountStatus',
            type: 'slot',
            slot: true,
            editSlot: true,
            disabled: true,
            optionsKey: 'CUSTOMER_TENDERER_ACCOUNT_STATUS',
            width: 90
        },
        {
            label: '绑定手机号',
            prop: 'registrantPhone',
            width: 150,
            type: 'slot',
            slot: true,
            verify: phoneReg,
            mustFill: true
        },
        {
            label: '账号绑定人',
            prop: 'accountRegistrant',
            width: 150,
            type: 'input'
        },
        {
            label: '账号绑定人名称',
            prop: 'accountRegistrantName',
            width: 120,
            slot: true,
            disabled: true
        },
        {
            label: '账号所有人',
            prop: 'accountManager',
            type: 'advance',
            mustFill: true,
            width: 160,
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: `/crmUser/page`,
            cbParams: ['esusLoginName#accountManager', 'esusUserNameCn#accountManagerName'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g');
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            }
        },
        {
            label: '账号所有人名称',
            prop: 'accountManagerName',
            width: 120
        },
        {
            label: '账号所有人状态',
            prop: 'accountManagerStatus',
            optionsKey: 'CRM_USER_INFO_STATUS',
            width: 120
        },
        {
            label: '90天内是否有更新',
            prop: 'hasUpdateIn90days',
            type: 'slot',
            slot: true,
            editSlot: true,
            optionsKey: 'YES_OR_NO',
            disabled: true,
            width: 140
        },
        {
            label: '备注',
            prop: 'remark',
            width: 180,
            type: 'slot',
            slot: true,
            editSlot: true,
            maxlength: 500
        },
        {
            label: '是否已复核',
            prop: 'isReviewed',
            type: 'select',
            optionsKey: 'YES_OR_NO',
            width: 100
        },
        {
            label: '创建时间',
            prop: 'createTime',
            width: 150
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            width: 150
        },
        {
            label: '账号所有人更新时间',
            prop: 'managerUpdateTime',
            width: 170
        },
        {
            label: '密码更新时间',
            prop: 'passwordUpdateTime',
            width: 160
        }
    ],
    actions: {
        fixedWidth: 150,
        list: [
            {
                label: '废弃',
                event: 'discard',
                displayRule: (row) => {
                    const hasAuth = otherUtils.getHasAuth(btnAuthority.biddingAccountManage.discard);
                    const isCreator = row.createUserCode === row.accountRegistrant;
                    const isActive = row.accountStatus === 'active';
                    return hasAuth && isCreator && isActive;
                }
            },
            {
                label: '重启',
                event: 'enable',
                displayRule: (row) => {
                    const hasAuth = otherUtils.getHasAuth(btnAuthority.biddingAccountManage.enable);
                    const isCreator = row.createUserCode === row.accountRegistrant;
                    const isNotActive = row.accountStatus !== 'active';
                    return hasAuth && isCreator && isNotActive;
                }
            }
        ]
    }
};
